import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllPartnerInfoSlice = createSlice({
    name: "getAllPartnerInfo",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllPartnerInfoSlice_actions = getAllPartnerInfoSlice.actions;
export var fetchData = _getAllPartnerInfoSlice_actions.fetchData, fetchDataSuccess = _getAllPartnerInfoSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllPartnerInfoSlice_actions.fetchDataFailure, resetState = _getAllPartnerInfoSlice_actions.resetState;
export default getAllPartnerInfoSlice.reducer;
